<template>
  <div>
    <div class="row px-5">
      <div class="col">
        <div class="d-flex justify-content-end align-items-center">
          <div style="width: 60px; height: 60px">
            <circle-loader
              v-if="paymentPercentage < 100"
              circle-class="custom-circle-loader"
              has-icon
              icon-class="green-color"
              :percentage="paymentPercentage"
            >
              <text
                :fill="
                  paymentPercentage == 100
                    ? 'background-green #000000'
                    : '#E5F5EF'
                "
                font-family="Font Awesome\ 5 Free"
                font-size="18"
                font-weight="900"
                x="8"
                y="25.35"
              >
                &#xf00c;
              </text>
            </circle-loader>
            <i v-else class="fas fa-check-circle fa-3x green-color" />
          </div>
          <div class="ml-2 mt-2">
            <div class="color-secondary-6 font-14">
              Monto Total:
            </div>
            <div>
              <div>
                <span class="color-green font-weight-bold font-22">
                  {{ billingTotal | price }}
                </span>
                /
                <span class="color-secondary-6 font-16">
                  {{ disbursementAmount | price }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="row mx-auto mb-3">
          <icon-view
            class="col-12 col-md-9"
            gradient
            icon="fa fa-dollar-sign"
            icon-background="#FF7058"
            icon-color="#fff"
            title="Adjudicación por Cifra de Cuenta"
          />
        </div>
        <div class="row mb-3 bg-secondary-13 pt-3 ml-2 rounded">
          <div class="col-12 py-0 px-2">
            <div class="row px-4">
              <div class="col-3 d-flex align-items-center">
                <span class="fa-stack fa-1x color-green font-14 mr-3">
                  <em class="fas fa-circle fa-stack-2x" />
                  <em class="fas fa-usd-square fa-stack-1x fa-inverse" />
                </span>
                <span class="color-gray-6 font-16 font-weight-normal mr-2">
                  Número de Voucher:
                </span>
                <span
                  v-if="
                    canManuallySetVoucherId &&
                      disbursementInfo.requireVoucherNumber &&
                      !disbursementInfo.voucherNumber
                  "
                >
                  <validation-observer ref="voucherNumberRef" novalidate>
                    <validation-provider v-slot="{ errors }" rules="required">
                      <custom-input
                        v-model="voucherNumber"
                        class="custom-input__extended w-100"
                        custom-error-msg="El voucher es requerido."
                        :error="errors[0]"
                      />
                    </validation-provider>
                  </validation-observer>
                </span>
                <span v-else class="color-black font-16 font-weight-normal">
                  {{ disbursementInfo.voucherNumber | empty }}
                </span>
              </div>
              <div class="col d-flex justify-content-end align-items-center">
                <span class="color-gray-6 font-16 font-weight-normal mr-2">
                  Fecha de Voucher:
                </span>
                <validation-observer
                  v-if="canSetVoucherDate && canManuallySetVoucherId"
                  ref="voucherDateRef"
                  novalidate
                >
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-date-picker
                      v-model="disbursementInfo.voucherDate"
                      :custom-error-msg="'La fecha de voucher es requerida.'"
                      :error="errors[0]"
                    />
                  </validation-provider>
                </validation-observer>
                <span v-else class="color-black font-16 font-weight-normal">
                  {{ disbursementInfo.voucherDate | date }}
                </span>
              </div>
              <div class="col d-flex justify-content-end">
                <div class="d-flex align-items-center justify-content-end p-0">
                  <span class="color-gray-6 font-16 font-weight-normal mr-3">
                    Número de Pago:
                  </span>
                  <span
                    v-if="isSentToBusinessStatus && canManuallySetVoucherId"
                  >
                    <validation-observer ref="paymentIdFormRef" novalidate>
                      <validation-provider v-slot="{ errors }" rules="required">
                        <custom-input
                          v-model="paymentId"
                          class="custom-input__extended mr-2"
                          :custom-error-msg="'El número de pago es requerido.'"
                          :error="errors[0]"
                          maxlength="50"
                        />
                      </validation-provider>
                    </validation-observer>
                  </span>
                  <span
                    v-else
                    class="color-black font-16 font-weight-normal mr-5"
                  >
                    {{ paymentId | empty }}
                  </span>
                </div>
              </div>
              <div class="col d-flex justify-content-end align-items-center">
                <span class="color-gray-6 font-16 font-weight-normal mr-2">
                  Fecha de Pago:
                </span>
                <validation-observer
                  v-if="isEnviadoAFinanzasStatus && canManuallySetVoucherId"
                  ref="paymentDateRef"
                  novalidate
                >
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-date-picker
                      v-model="disbursementInfo.paymentDate"
                      :custom-error-msg="'La fecha de pago es requerida.'"
                      :error="errors[0]"
                    />
                  </validation-provider>
                </validation-observer>
                <span v-else class="color-black font-16 font-weight-normal">
                  {{ disbursementInfo.paymentDate | date }}
                </span>
              </div>
              <div class="col-auto d-flex align-items-end justify-content-end">
                <action-button
                  v-if="disbursementInfo.voucherNumber && isDirectPayment"
                  class="d-flex justify-content-center align-items-center ml-3"
                  i="fas fa-redo-alt"
                  variant="outline-success"
                  @click="onUpdatePurchaseOrderHandler"
                />
              </div>
            </div>
            <hr />
            <div
              v-if="isPurchaseOrdersEmpty"
              class="col-12 bg-white rounded p-4 d-flex align-items-center justify-content-center"
            >
              <action-button
                id="btn-insert-row-number"
                class="border w-40 btn"
                i="fas fa-file-plus color-primary-1"
                text="Presione aquí para añadir cifra"
                @click="openNewDigitForm"
              />
            </div>
            <div
              v-for="(digit,
              index) in disbursementInfo.disbursementPurchaseOrderNumbers"
              :key="`payment_list_${index}`"
              class="bg-white rounded py-3 mb-3 px-3 mt-3"
            >
              <div class="row">
                <div class="col-md-4 mt-1">
                  <div class="color-secondary-6 font-14">
                    Número de Cifra:
                  </div>
                  <div class="color-black font-16">
                    {{ digit.fullNumber }}
                  </div>
                </div>
                <div class="col-sm col-md-2 mt-1">
                  <div class="color-secondary-6 font-14">
                    Número de línea:
                  </div>
                  <div class="color-black font-16">
                    {{ digit.lineNumber }}
                  </div>
                </div>
                <div class="col-sm col-md-2 mt-1">
                  <div class="color-secondary-6 font-14">
                    Tipo de Cifra:
                  </div>
                  <div class="color-black font-16">
                    {{ digit.digitType }}
                  </div>
                </div>
                <div class="col-sm col-md-2 mt-3 mt-md-1 mt-sm-3">
                  <div class="color-secondary-6 font-14">
                    Monto:
                  </div>
                  <div class="color-black font-16 font-14">
                    {{ digit.amount | price }}
                  </div>
                </div>
                <div class="col-sm col-md-2 mt-1 d-flex justify-content-end">
                  <action-button
                    v-if="isApprovedStatus || isInPaymentProcess"
                    id="btn-remove-digit"
                    i="fas fa-times-circle"
                    variant="outline-danger btn-cancel danger m-2 pr-4"
                    @click="deleteDigit(digit)"
                  >
                    Eliminar
                  </action-button>
                </div>
              </div>
            </div>
            <div
              v-if="
                disbursementInfo.addDigitForm && !disbursementInfo.voucherNumber
              "
              class="row mt-3 bg-white rounded p-2 mx-0"
            >
              <div class="col">
                <div class="mb-2">
                  <validation-observer
                    ref="disbursementRequestPaymentResultRef"
                    novalidate
                    tag="form"
                  >
                    <div class="row">
                      <div class="col-md-4">
                        <div class="color-secondary-6 font-14">
                          Número de Cifra:
                        </div>
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <custom-drop-down
                            v-model="value.purchaseOrderNumber"
                            class="w-100"
                            :clearable="false"
                            custom-error-msg="La cifra de cuenta es requerida."
                            :error="errors[0]"
                            fieldkey="id"
                            fieldname="name"
                            :options="digitNumbers"
                            placeholder="Seleccione"
                            @input="onPurchaseOrderChange"
                          />
                        </validation-provider>
                      </div>
                      <div class="col-sm col-md-2 mt-1">
                        <div class="color-secondary-6 font-14">
                          Número de línea:
                        </div>
                        <div class="color-black font-16">
                          {{ lineNumber | empty }}
                        </div>
                      </div>
                      <div class="col-sm col-md-3 mt-1">
                        <div class="color-secondary-6 font-14">
                          Tipo de Cifra:
                        </div>
                        <div class="color-black font-16">
                          {{ digitType | empty }}
                        </div>
                      </div>
                      <div class="col-sm col-md-3 mt-3 mt-md-1 mt-sm-3">
                        <div class="color-secondary-6 font-14">
                          Monto:
                        </div>
                        <validation-provider
                          v-slot="{ errors }"
                          :custom-messages="{
                            required: 'El monto es requerido.',
                            greaterThanZero: 'El monto debe ser mayor de 0.',
                          }"
                          rules="required|greaterThanZero"
                        >
                          <div class="input-group mb-3">
                            <custom-input
                              v-model="value.amount"
                              class="custom-input__extended w-100"
                              :custom-error-msg="
                                'La cantidad debe ser mayor a 0.'
                              "
                              :error="errors[0]"
                              mask-type="Money"
                              prepend-icon="fa fa-dollar-sign"
                              :prepend-icon-left="true"
                              prepend-icon-type="success"
                            />
                          </div>
                        </validation-provider>
                      </div>
                      <div
                        class="col-md-12 mt-1 d-flex align-items-center justify-content-end"
                      >
                        <action-button
                          id="btn-cancel-digit"
                          i="fas fa-times-circle"
                          variant="outline-danger btn-cancel danger  m-2 pl-4 pr-4"
                          @click="cancelDigit()"
                        >
                          Cancelar
                        </action-button>
                        <action-button
                          id="btn-save-digit"
                          i="fas fa-save"
                          variant="success m-2 pl-4 pr-4"
                          @click="saveDigit()"
                        >
                          Guardar
                        </action-button>
                      </div>
                    </div>
                  </validation-observer>
                </div>
              </div>
            </div>
            <div
              v-if="
                disbursementInfo.disbursementPurchaseOrderNumbers.length > 0 &&
                  !disbursementInfo.addDigitForm &&
                  (isApprovedStatus || isInPaymentProcess)
              "
              class="text-right mt-2"
            >
              <action-button
                id="btn-add-digit"
                i="fas fa-file-plus"
                text="Añadir Cifra"
                variant="success px-3"
                @click="openNewDigitForm()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="hasPurchaseOrders">
      <section-title :has-line="true" title="Documentos" />
      <custom-callout
        v-if="determinationId == 3"
        :has-border="false"
        :has-toggle="false"
      >
        <div class="row col-12 pr-0">
          <div class="row col-8">
            <div class="row col-12 col-md-6">
              <div class="col-12">
                <span class="data-title d-block border-mobile">
                  Documento:
                </span>
                <span class="font-16 color-black">
                  {{ 'Carta de Autorización' | empty }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-4 d-flex align-items-center justify-content-end">
            <action-button
              class="ab-btn px-2 download-btn ab-btn-success"
              i="fas fa-download mx-1"
              @click="onDownloadRefundReport"
            />
          </div>
        </div>
      </custom-callout>
      <validation-observer ref="paymentDocumentFormRef">
        <validation-provider
          v-for="(document, index) in documents"
          :key="`document-${index}`"
          v-slot="{ errors }"
          :custom-messages="{
            required_if: docValidationMessage(document),
          }"
          :disabled="
            !isReimbursementCertification(document.documentTypeId)
              ? 'disabled'
              : false
          "
          :rules="{
            required_if:
              !document.documentId && !isDisbursementCertificationExceptionYear,
          }"
        >
          <DocumentView
            :can-add-document="
              isReimbursementCertification(document.documentTypeId) &&
                (isApprovedStatus || isInPaymentProcess)
            "
            :document-file-name="document.documentFilename"
            :document-id="document.documentId"
            :document-name="document.documentTypeName"
            :document-type-id="document.documentTypeId"
            :request-id="requestId"
            :show-replace-button="
              isReimbursementCertification(document.documentTypeId) &&
                (isApprovedStatus || isInPaymentProcess)
            "
            @on-document-added="
              (docValue) => onDocumentAddedHandler(document, docValue)
            "
          />
          <custom-error
            v-if="errors[0] && errors[0].length > 0"
            :message="errors[0]"
            variant="no-border"
          />
        </validation-provider>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import CircleLoader from '@/components/common/loaders/CircleLoader';
import IconView from 'icon-view';
import ActionButton from 'ActionButton';
import disbursementRequestStatuses from '@/utils/shared/constants/disbursementRequestStatuses';
import CustomInput from 'CustomInput';
import { getDigitNumbers as _getDigitNumbers } from '@/modules/reinbursement/api.js';
import CustomDropDown from 'custom-drop-down';
import CustomError from 'custom-error';
import voucherStatus from '@/utils/constants/voucherStatus';
import DocumentView from './DocumentView.vue';
import SectionTitle from 'SectionTitle';
import alert from 'utils/mixins/alert.mixin';
import mixWait from '@/mixins/vue-loading.js';
import codeDocumentTypes from '@/utils/constants/documentTypes';
import CustomDatePicker from '@/components/common/form/CustomDatePicker';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';
import sysparameterByNames from '@/utils/constants/sysParameterNames';
import determinationTypes from '@/utils/constants/determinationTypes';
import CustomCallout from 'custom-callout';
import AppServices from '@/modules/app/api.js';

export default {
  name: 'PaymentView',
  components: {
    CircleLoader,
    IconView,
    ActionButton,
    CustomInput,
    CustomDropDown,
    DocumentView,
    SectionTitle,
    CustomError,
    CustomDatePicker,
    CustomCallout,
  },
  mixins: [alert, mixWait],
  props: {
    value: {
      //Form
      type: Object,
      default: () => {
        return {
          //Only related to Forms
          purchaseOrderNumberId: 0,
          purchaseOrderNumber: null,
          amount: 0,
          billId: 0,
          purchaseOrderId: null,
          lineNumber: null,
          billingPaymentId: null,
        };
      },
    },
    disbursementInfo: {
      type: Object,
      default: () => {
        return {
          disbursementPurchaseOrderNumbers: [],
          purchaseOrderNumbers: [],
          totalPurchase: 0,
          disbursementTotal: 0,
          addDigitForm: false,
          purchaseOrderId: null,
          requireVoucherNumber: false,
          isBulk: false,
        };
      },
    },
    disbursementStatus: {
      type: Number,
      default: 0,
    },
    disbursementAmount: {
      type: Number,
      default: 0,
    },
    determinationId: {
      type: Number,
      default: 0,
    },
    documents: {
      type: Array,
      default: () => [],
    },
    requestId: {
      type: Number,
      default: 0,
    },
    year: {
      type: Number,
      default: 0,
    },
    paymentModel: {
      type: String,
      default: null,
    },
    canManuallySetVoucherId: {
      type: Boolean,
      default: false,
    },
    tapRequestId: {
      type: Number,
      default: 0,
    },
    academicYearId: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    lineNumber: null,
    digitNumbers: null,
    billingServiceCategoryName: null,
    digitType: null,
    voucherNumber: null,
    paymentId: null,
    sysParameters: [],
  }),
  computed: {
    isDirectPayment() {
      return determinationTypes.DirectPayment === this.determinationId;
    },
    paymentPercentage() {
      return (
        (this.disbursementInfo.totalPurchase / this.disbursementAmount) * 100
      );
    },
    billingTotal() {
      return this.disbursementInfo.isBulk
        ? this.disbursementAmount
        : this.disbursementInfo.totalPurchase;
    },
    isPurchaseOrdersEmpty() {
      return (
        this.disbursementInfo.disbursementPurchaseOrderNumbers?.length == 0 &&
        !this.disbursementInfo.addDigitForm &&
        (this.isApprovedStatus || this.isInPaymentProcess)
      );
    },
    isApprovedStatus() {
      return this.disbursementStatus == disbursementRequestStatuses.Aprobado;
    },
    isInPaymentProcess() {
      return (
        this.disbursementStatus === disbursementRequestStatuses.EnProcesoDePago
      );
    },
    totalPurchase() {
      let total = 0;
      if (this.disbursementInfo.voucherStatus == voucherStatus.Cancelled) {
        return 0;
      }

      this.disbursementInfo.disbursementPurchaseOrderNumbers.map((item) => {
        total += item.amount;
      });
      return total;
    },
    hasPurchaseOrders() {
      return Boolean(
        this.disbursementInfo?.disbursementPurchaseOrderNumbers?.length
      );
    },
    isReimbursementCertification() {
      return (documentTypeId) =>
        documentTypeId === codeDocumentTypes.ReimbursementCertification;
    },
    docValidationMessage() {
      return (item) => {
        switch (item.documentTypeId) {
          case codeDocumentTypes.ReimbursementCertification:
            return 'El documento de certificación de reembolso es requerido.';
          default:
            return '';
        }
      };
    },
    isSentToBusinessStatus() {
      return (
        this.disbursementStatus === disbursementRequestStatuses.EnviadoAFinanzas
      );
    },
    canSetVoucherDate() {
      const voucherDateValidStatuses = [disbursementRequestStatuses.Aprobado];
      return voucherDateValidStatuses.includes(this.disbursementStatus);
    },
    isEnviadoAFinanzasStatus() {
      return (
        this.disbursementStatus === disbursementRequestStatuses.EnviadoAFinanzas
      );
    },
    isDisbursementCertificationExceptionYear() {
      const exclusiveAcademicYearParameter = this.sysParameters.find(
        (x) =>
          x.name ===
          'ExclusiveAcademicYearsForDisbursementCertificationValidation'
      );
      const isExclusiveAcademicYear = exclusiveAcademicYearParameter?.staticValue?.includes(
        this.academicYearId
      );

      return isExclusiveAcademicYear;
    },
  },
  watch: {
    'disbursementInfo.disbursementPurchaseOrderNumbers'(newValue) {
      if (newValue != undefined) {
        this.disbursementInfo.totalPurchase = this.totalPurchase;
      }
    },
    'disbursementInfo.addDigitForm'() {
      this.clearForm();
    },
  },
  created() {
    this.disbursementInfo.totalPurchase = this.totalPurchase; //For gears
    this.paymentId = this.paymentModel;
  },
  async mounted() {
    await this.getParameters();
  },
  methods: {
    openNewDigitForm() {
      this.disbursementInfo.addDigitForm = true;
      this.ShowWait();
      _getDigitNumbers(this.year)
        .then((data) => {
          let response = data.data.filter((t) => {
            return (
              this.disbursementInfo.disbursementPurchaseOrderNumbers.filter(
                (q) => {
                  return (
                    q.lineNumber == t.lineNumber &&
                    t.purchaseOrderNumberId == q.purchaseOrderNumberId &&
                    t.lineStatus !== 'C'
                  );
                }
              ).length == 0
            );
          });
          this.digitNumbers = response.sort((a, b) =>
            a.lineNumber > b.lineNumber
              ? 1
              : b.lineNumber > a.lineNumber
              ? -1
              : 0
          );
          this.HideWait();
        })
        .catch(this.HideWait());
    },
    cancelDigit() {
      this.disbursementInfo.addDigitForm = false;
    },
    clearForm() {
      this.value.purchaseOrderNumber = null;
      this.value.purchaseOrderNumberId = null;
      this.value.lineNumber = null;
      this.value.digitType = null;
      this.value.amount = 0;
    },
    onPurchaseOrderChange(value) {
      this.balance = value.doeBalanceAmount;
      this.lineNumber = value.lineNumber;
      this.digitType = value.digitType;
    },
    async saveDigit() {
      let isValid = await this.$refs.disbursementRequestPaymentResultRef.validate();
      if (!isValid) {
        this.ShowToast('', 'Debe completar los campos requeridos.', 'error');
        return;
      }

      if (
        this.value.amount + this.disbursementInfo.totalPurchase >
        this.disbursementAmount
      ) {
        this.ShowToast(
          '',
          'La cantidad sobrepasa el monto de la solicitud.',
          'error'
        );
        return;
      }

      this.value.lineNumber = this.lineNumber;

      this.$emit('saveDigit');
      this.disbursementInfo.totalPurchase = this.totalPurchase;

      this.lineNumber = null;
      this.digitType = null;
    },
    async getVoucherNumber() {
      return new Promise((resolve) => {
        resolve({
          voucherNumber: this.voucherNumber,
        });
      });
    },
    async getVoucherDate() {
      return new Promise((resolve) => {
        resolve({
          voucherDate: this.disbursementInfo.voucherDate,
        });
      });
    },
    async getPaymentDate() {
      return new Promise((resolve) => {
        resolve({
          paymentDate: this.disbursementInfo.paymentDate,
        });
      });
    },
    async validateVoucherNumber() {
      return this.$refs.voucherNumberRef.validate();
    },
    async validateVoucherDate() {
      return this.$refs.voucherDateRef.validate();
    },
    async validatePaymentDate() {
      return this.$refs.paymentDateRef.validate();
    },
    deleteDigit(digit) {
      this.$emit('delete-digit', digit);
    },
    onUpdatePurchaseOrderHandler() {
      this.$emit('on-update-po', this.disbursementInfo.voucherNumber);
    },
    async onDocumentAddedHandler(document, docValue) {
      if (document && docValue) {
        document.documentId = docValue;
        await this.$refs.paymentDocumentFormRef.reset();
      }
    },
    async validateDocument(newStatusId) {
      return newStatusId === disbursementRequestStatuses.EnProcesoDePago
        ? true
        : (await this.$refs?.paymentDocumentFormRef?.validate()) ?? true;
    },
    async validatePaymentId() {
      if (!this.isSentToBusinessStatus) return true;
      const isValid = await this.$refs?.paymentIdFormRef?.validate();
      return isValid;
    },
    async getParameters() {
      const { data: sysParameters } = await _getSysparameterByNames({
        parameterNames: [
          sysparameterByNames.ExclusiveAcademicYearsForDisbursementCertificationValidation,
          sysparameterByNames.DirectPaymentSifde,
        ],
      });
      this.sysParameters = sysParameters;
    },
    async onDownloadRefundReport() {
      if (this.isDirectPayment) {
        await AppServices.getTapRequestDirectPaymentReport({
          requestId: this.tapRequestId,
        });
      } else {
        await AppServices.getTapRequestRefundReport({
          requestId: this.tapRequestId,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.custom-circle-loader {
  stroke: #e5f5ef !important;
}

.green-color {
  color: map-get($colors, 'green');
}

::v-deep .custom-input__extended {
  .input-group {
    .input-group-text {
      background: map-get($colors, 'green');
      color: map-get($colors, 'white');
    }
  }
}
</style>
